import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

// Bug real reportado en auditoría: la ruta standalone '/usuarios' solo tenía
// authGuard (exige sesión), no verificaba el permiso 'customers' -- el
// dashboard SÍ lo exige para mostrar/permitir la pestaña "Clientes"
// (ver isTabAllowed en dashboard.component.ts), pero un empleado sin ese
// permiso podía saltarse ese control tecleando /usuarios directamente en
// la URL y ver el directorio completo de clientes del negocio.
export const customersAccessGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  if (authService.hasPermission('customers')) {
    return true;
  }

  router.navigate(['/dashboard']);
  return false;
};
